import { Navigate, useLocation } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <main className="flex min-h-screen items-center justify-center bg-[#f2efe7]" data-testid="dashboard-auth-loading"><LoaderCircle className="animate-spin text-[#244234]" size={38}/></main>;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  return children;
}